import { render, staticRenderFns } from "./ServiceContractDetail.vue?vue&type=template&id=b5b0f206&scoped=true"
import script from "./ServiceContractDetail.vue?vue&type=script&lang=js"
export * from "./ServiceContractDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b0f206",
  null
  
)

export default component.exports